import MDBox from "components/MDBox";

import React from "react";
import { CircularProgress } from "@mui/material";
import { useGetCicloByIdQuery, useGetExamenesQuery } from "services";
import TabsCardCalificaciones from "components/TabsCard/tabs_calificaciones";
import { useLocation, useNavigate } from "react-router-dom";
import { calificaciones } from "slices";
import { useSelector } from "react-redux";
import SelectCarrerasCalificaciones from "./components/selectCarreras";
import ExamenEvaluacion from "./components/examen-evaluacion/ExamenEvaluacion";
import { useSnackbar } from "notistack";
import { HOME_URL } from "config/bases_url";

function DataTableWithTabs() {
  const {
    cicloSeleccionado,
    carreraSelect,
    loading: divisionLoading,
  } = useSelector(calificaciones);
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  if (!cicloSeleccionado)
    return (
      <MDBox
        mt={5}
        width={"100%"}
        display={"flex"}
        py={5}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
      </MDBox>
    );

  const { data: examenes, isLoading } = useGetExamenesQuery({
    filter_params: {
      query: "{id,examen{url,id,nombre},desfase,estados,anterior,compartido}",
    },
    shape: {
      id: "examen.id",
      wrapperId: "id",
      nombre: "examen.nombre",
      url: "examen.url",
      desfase: "desfase",
      estado: "estados",
      anterior: "anterior",
      compartido: "compartido",
    },
  });

  if (divisionLoading) {
    return (
      <MDBox
        mt={5}
        width={"100%"}
        display={"flex"}
        py={5}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
      </MDBox>
    );
  }

  React.useEffect(() => {
    if (cicloSeleccionado?.carreras?.length === 0) {
      enqueueSnackbar(
        "Debe confeccionar los grupos por carreras, y luego los estudiantes a los grupos para acceder a las calificaciones",
        {
          variant: "warning",
          autoHideDuration: 8000,
        }
      );
      navigate(HOME_URL);
    }
  }, [cicloSeleccionado]);

  // Este efecto se ejecutará cada vez que cambie la ubicación (ruta)
  React.useEffect(() => {
    // Verificar condiciones cuando la ubicación cambie
    if (examenes?.length === 0) {
      enqueueSnackbar(
        "Debe existir al menos un exámen en la configuración para mostrar las calificaciones",
        {
          variant: "warning",
          autoHideDuration: 8000,
        }
      );
      navigate(HOME_URL);
      return;
    }
  }, [examenes]);

  return (
    <MDBox pb={3} key={location.pathname}>
      {!_.isEmpty(carreraSelect) || !_.isEmpty(cicloSeleccionado?.carreras) ? (
        <SelectCarrerasCalificaciones carreras={cicloSeleccionado?.carreras} />
      ) : null}
      {isLoading ? (
        <MDBox
          width={"100%"}
          display={"flex"}
          py={5}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
        </MDBox>
      ) : (
        <TabsCardCalificaciones
          tabs={examenes?.map((el) => {
            return {
              id: String(el.nombre).toLowerCase(),
              label: el.nombre,
              element: (
                <ExamenEvaluacion
                  tableHeader={el.nombre}
                  ciclo={{
                    name: cicloSeleccionado.nombre,
                    id: cicloSeleccionado.id,
                    activo: cicloSeleccionado.activo,
                    url: cicloSeleccionado.url,
                  }}
                  examen={{
                    id: el.wrapperId,
                    name: el.nombre,
                    desfase: el.desfase,
                    estadosEstudiantes: el.estado,
                    haveAnterior: !!el.anterior,
                    anteriorName: el.anterior?.examen.nombre,
                    compartido: el.compartido,
                    url: el.url,
                  }}
                />
              ),
            };
          })}
        />
      )}
    </MDBox>
  );
}

export default DataTableWithTabs;
